import { safeHttpUrl } from './config.js'

const configuredHosts = (import.meta.env?.VITE_APP_OSS_IMAGE_HOSTS || '').split(',').map(host => host.trim()).filter(Boolean)

export function detailImageSize(width = globalThis.innerWidth || 1280, ratio = globalThis.devicePixelRatio || 1) {
  const available = width > 1200 ? width - 615 : width > 900 ? width - 472 : width - 48
  return Math.min(1600, Math.max(640, Math.ceil(Math.min(1280, available) * Math.min(1.5, Math.max(1, ratio)) / 160) * 160))
}

// 仅处理已知 OSS / 显式配置的图片域名；签名地址不改写，避免破坏签名。
export function sizedAppImage(source, size = 640) {
  const safe = safeHttpUrl(source)
  if (!safe) return source || ''
  const url = new URL(safe)
  if (!/\.oss[-.][a-z0-9-]+\.aliyuncs\.com$/i.test(url.hostname) && !configuredHosts.includes(url.hostname)) return source
  if ([...url.searchParams.keys()].some(key => /^(signature|ossaccesskeyid|expires|x-oss-signature|x-oss-credential)$/i.test(key))) return source
  if (url.searchParams.has('x-oss-process')) return source
  const edge = Math.min(1920, Math.max(64, Math.round(Number(size) || 640)))
  url.searchParams.set('x-oss-process', `image/resize,m_lfit,w_${edge},h_${edge},limit_1/quality,q_85/format,webp`)
  return url.href
}
